'use client';
import { useState } from 'react';

/**
 * Reads the CSP nonce from the <meta name="csp-nonce"> tag injected by nginx.
 * The nonce is unique per request ($request_id) and must be passed to third-party
 * scripts (GTM, New Relic) so they can create inline scripts that satisfy CSP.
 */
export default function useCspNonce(): string | undefined {
  const [nonce] = useState(() => {
    if (typeof document === 'undefined') return undefined;
    return document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? undefined;
  });
  return nonce;
}
